import 'css-chunk:src/app/context/ClientContext.module.scss';export default {
  "ClientContext": "_ClientContext_g6u09_1",
  "loading": "_loading_g6u09_7",
  "notice": "_notice_g6u09_10"
};